import { MenuItem } from '../shared/models';

// Order here is the order in the sidebar; `group` places the item under its section
export const MENU: MenuItem[] = [
  {
    label: 'Inicio',
    route: '/dashboard',
    anyOf: ['dashboard.view'],
    iconKey: 'dashboard',
  },
  {
    label: 'Calendario',
    route: '/agendas',
    group: 'agenda',
    anyOf: ['agendas.view'],
    iconKey: 'agendas',
  },
  {
    label: 'Solicitudes de cita',
    route: '/agendas/requests',
    group: 'agenda',
    anyOf: ['agendas.view'],
    iconKey: 'schedule-pending',
  },
  {
    label: 'Turnos',
    route: '/agendas/walk-ins',
    group: 'agenda',
    anyOf: ['agendas.view'],
    iconKey: 'walk-ins',
  },
  {
    label: 'Clientes',
    route: '/people',
    group: 'business',
    anyOf: ['customers.view'],
    iconKey: 'customers',
  },
  {
    label: 'Servicios',
    route: '/services',
    group: 'business',
    anyOf: ['services.view'],
    iconKey: 'services',
  },
  {
    label: 'Profesionales',
    route: '/professionals',
    group: 'business',
    anyOf: ['staff.view'],
    iconKey: 'staff',
  },
  {
    label: 'Ventas',
    route: '/sales',
    group: 'sales',
    anyOf: ['inventory.view'],
    iconKey: 'finance',
    requiredFeature: 'Ventas y reportes integrados',
  },
  {
    label: 'Productos',
    route: '/inventory',
    group: 'sales',
    anyOf: ['inventory.view'],
    iconKey: 'inventory',
    requiredFeature: 'Gestión de productos e inventario',
  },
  {
    label: 'Promociones',
    route: '/promos',
    group: 'sales',
    anyOf: ['promos.view'],
    iconKey: 'promos',
    requiredFeature: 'Promociones y campañas',
  },
  {
    label: 'Informes',
    route: '/reports',
    group: 'sales',
    anyOf: ['events.view', 'agendas.view'],
    iconKey: 'reports',
  },
  {
    label: 'Configuración',
    route: '/settings',
    group: 'system',
    anyOf: ['bundles.view'],
    iconKey: 'settings',
  },
  {
    label: 'Administración del Sistema',
    route: '/system-admin',
    group: 'system',
    anyOf: ['sysadmin'], // Special permission for sysadmin role
    iconKey: 'settings',
  },
];
